import { H3 } from "@verse_core/shared_components/base/TextComponents/H3";
import { H5 } from "@verse_core/shared_components/base/TextComponents/H5";
import { P2 } from "@verse_core/shared_components/base/TextComponents/P2";

const PatientRights = () => {
  const olStyle = "tw-mb-0";
  const liStyle = "tw-pl-[10px]";
  const subheadingStyle = "tw-mt-[72px] tw-mb-[24px]";

  return (
    <div className="tw-mb-[172px] tw-flex tw-w-full tw-justify-center tw-px-[10px]">
      <div className="tw-w-full tw-max-w-[1024px]">
        <div className="tw-mt-[96px] tw-flex tw-justify-center">
          <H3 className="tw-my-0">Patient Rights and Responsibilities</H3>
        </div>
        <div>
          <H5 className={subheadingStyle}>Patient Rights</H5>
          <ol className={olStyle}>
            <li className={liStyle}>
              The patient has the right to considerate and respectful service.
            </li>
            <li className={liStyle}>
              The patient has the right to obtain service without regard to
              race, creed, national origin, sex, age, disability, diagnosis or
              religious affiliation.
            </li>
            <li className={liStyle}>
              Subject to applicable law, the patient has the right to
              confidentiality of all information pertaining to his/her medical
              equipment service. Individuals or organizations not involved in
              the patient's care, may not have access to the information without
              the patient's written consent.
            </li>
            <li className={liStyle}>
              The patient has the right to make informed decisions about his/her
              care.
            </li>
            <li className={liStyle}>
              The patient has the right to reasonable continuity of care and
              service.
            </li>
            <li className={liStyle}>
              The patient has the right to voice grievances without fear of
              termination of service or other reprisal in the service process.
            </li>
          </ol>
        </div>
        <div>
          <H5 className={subheadingStyle}>Patient Responsibilities</H5>
          <ol className={olStyle}>
            <li className={liStyle}>
              The patient should promptly notify the Home Medical Equipment
              Company of any equipment failure or damage.
            </li>
            <li className={liStyle}>
              The patient is responsible for any equipment that is lost or
              stolen while in their possession and should promptly notify the
              Home Medical Equipment Company in such instances.
            </li>
            <li className={liStyle}>
              The patient should promptly notify the Home Medical Equipment
              Company of any changes to their address or telephone.
            </li>
            <li className={liStyle}>
              The patient should promptly notify the Home Medical Equipment
              Company of any changes concerning their physician.
            </li>
            <li className={liStyle}>
              The patient should notify the Home Medical Equipment Company of
              discontinuance of use.
            </li>
            <li className={liStyle}>
              Except where contrary to federal or state law, the patient is
              responsible for any equipment rental and sale charges which the
              patient’s insurance company/companies does not pay.
            </li>
          </ol>
        </div>
        <div>
          <H5 className={subheadingStyle}>Warranty</H5>
          <P2>
            Every product sold by our company carries a warranty. We notify all
            Medicare beneficiaries/customers of the warranty coverage, and we
            will honor all warranties under applicable law. We will repair or
            replace, free of charge, Medicare-covered equipment that is under
            warranty. In addition, an owner's manual with warranty information
            will be provided to beneficiaries for all durable medical equipment
            where this manual is available.
          </P2>
        </div>
        <div>
          <H5 className={subheadingStyle}>
            Medicare DMEPOS Supplier Standards (30) Statement
          </H5>
          <P2>
            The products and/or services provided to you by your supplier are
            subject to the supplier standards contained in the Federal
            regulations shown at 42 Code of Federal Regulations Section 424.57
            (c). These standards concern business professional and operational
            matters (e.g., honoring warranties, hours of operation). The full
            text of these standards can be obtained from{" "}
            <a
              href="https://www.cms.gov/Medicare/Provider-Enrollment-and-Certification/MedicareProviderSupEnroll/downloads/DMEPOSSupplierStandards.pdf"
              target="_blank"
            >
              cms.gov
            </a>
            .
          </P2>
        </div>
        <div>
          <H5 className={subheadingStyle}>Text Message (SMS) Communications</H5>
          <P2>
            With your consent, we may contact you by text message (SMS) for
            purposes such as prescription refill reminders, reminders, and other
            communications related to your care.
          </P2>
          <P2>
            You may opt out of text messages at any time by replying STOP to any
            message. Message and data rates may apply.
          </P2>
          <P2>
            Your mobile phone number, SMS consent, and opt-in information will
            not be shared with or sold to third parties or affiliates for
            marketing or promotional purposes.
          </P2>
        </div>
      </div>
    </div>
  );
};

export default PatientRights;
